import { CommonModule, KeyValue } from "@angular/common";
import { ChangeDetectionStrategy, Component, InputSignal, input } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatChipInputEvent, MatChipsModule } from "@angular/material/chips";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { OfferGoalForm } from "../../../models/offers/offer-goal-forms";
import { ConversionType } from "@playcharge/common/models/backend/offers/conversion-type";
import { CampaignOfferGoalType } from "@playcharge/common/models/backend/offers/campaign-offer-goal-type";
import { EnumKeyValuePipe } from "../../../pipes/enumKeyValue.pipe";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { Nullable } from "@playcharge/common/models/backend/nullable";
import { FilterPipe } from "../../../pipes/filter.pipe";
import { MatButton } from "@angular/material/button";
import { NoScrollDirective } from "../../../directives/noScrollDirective";

@Component({
    selector: "app-offer-goal",
    standalone: true,
    imports: [
        CommonModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        MatDatepickerModule,
        MatSelectModule,
        MatChipsModule,
        MatIconModule,
        MatCheckboxModule,
        EnumKeyValuePipe,
        FilterPipe,
        MatButton,
        NoScrollDirective,
    ],
    templateUrl: "./offer-goal.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferGoalComponent {
    public formGroup: InputSignal<FormGroup<OfferGoalForm>> = input.required();

    public ConversionType: typeof ConversionType = ConversionType;
    public CampaignOfferGoalType: typeof CampaignOfferGoalType = CampaignOfferGoalType;

    public removeLevelUpValue(value: string): void {
        const input: FormControl<Nullable<string[]>> = this.formGroup().controls.levelUpValues;

        if (input.value) {
            const index = input.value.indexOf(value);

            if (index >= 0) {
                input.patchValue([...input.value.slice(0, index), ...input.value.slice(index + 1)]);
            }
        }
    }

    public addLevelUpValue(event: MatChipInputEvent): void {
        const value: string = event.value.trim();
        const input: FormControl<Nullable<string[]>> = this.formGroup().controls.levelUpValues;

        if (input.value) {
            input.patchValue([...input.value, value]);
        } else {
            input.patchValue([value]);
        }

        event.chipInput.clear();
    }

    public addCountryReward(): void {
        this.formGroup().controls.rewardsByCountries.push(
            new FormGroup({
                countryCode: new FormControl<string>("", {
                    nonNullable: true,
                    validators: [Validators.required],
                }),
                reward: new FormControl<number>(0, { nonNullable: true }),
            }),
        );
    }

    public removeCountryReward(index: number): void {
        this.formGroup().controls.rewardsByCountries.removeAt(index);
    }

    public filterFn(conversionType: KeyValue<string, string | number>): boolean {
        return (
            ConversionType[conversionType.key as keyof typeof ConversionType] !==
            ConversionType.None
        );
    }
}
